import { Component, Vue, Prop as prop} from 'nuxt-property-decorator';

@Component({
    components: {
       selectableList: require('~/components/form/selectable-list/').default,
    },
})
export default class CatalogSelectFilterComponent extends Vue {

    @prop()
    private value: CatalogFilterField;

    @prop()
    public opened: boolean;

    get selectedValueLabel() {
        if (this.value.values.length === 1) {
            return this.value.values[0].label;
        }

        return `Несколько (${this.value.values.length})`;
    }

    clear() {
        this.value.values = [];
    }

    get changed() {
        return !!this.value.values.length;
    }
}
